<template>
  <v-app>
    <Snackbar />
    <Loading />
    <v-sheet>
      <Navigation :active-url="activeUrl" />
    </v-sheet>
    <v-main>
      <slot></slot>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "App",
  props: {
    activeUrl: {
      type: String,
      default: "/"
    },
    user: {}
  },
  beforeMount() {
    if (this.activeUrl !== "login" && this.user != null) {
      this.me();
    }
  },
  methods: {
    ...mapActions("Auth", ["me"])
  }
};
</script>

<style></style>
